import { Accessor, PERMISSIONS } from 'models/Profile';

export type AdminNavChild = {
  to: string;
  title: string;
  accessor: Accessor | Accessor[];
  strictMode?: boolean;
};

export type AdminNavLink = {
  to?: string;
  title: string;
  accessor: Accessor | Accessor[];
  strictMode?: boolean;
  end?: boolean;
  children?: AdminNavChild[];
};

export const ADMIN_NAV_LINKS: AdminNavLink[] = [
  { to: '/admin/clients', title: 'Clients', accessor: PERMISSIONS.adminClientView, end: false },
  { to: '/admin/users', title: 'Users', accessor: PERMISSIONS.adminUserView },
  { to: '/admin/groups', title: 'Groups', accessor: PERMISSIONS.adminGroupView },
  { to: '/admin/locations', title: 'Locations', accessor: PERMISSIONS.adminGroupView },
  { to: '/admin/group-types', title: 'Group Types', accessor: PERMISSIONS.adminGroupTypeView },
  { to: '/admin/attributes', title: 'Attributes', accessor: PERMISSIONS.adminAttrView, end: false },
  {
    title: 'AI',
    accessor: [PERMISSIONS.adminAIPromptView, PERMISSIONS.adminAICriteriaView],
    strictMode: false,
    children: [
      { to: '/admin/ai-prompts', title: 'Embedded Prompts', accessor: PERMISSIONS.adminAIPromptView },
      {
        to: '/admin/admissions',
        title: 'Admissions',
        accessor: [PERMISSIONS.adminAIPromptView, PERMISSIONS.adminAICriteriaView],
        strictMode: false,
      },
      { to: '/admin/workspace-prompts', title: 'Workspace Prompts', accessor: PERMISSIONS.adminAIPromptView },
      { to: '/admin/generated-summaries', title: 'Generated Summaries', accessor: PERMISSIONS.adminAIPromptView },
    ],
  },
  {
    to: '/admin/question-templates',
    title: 'Question Templates',
    accessor: PERMISSIONS.adminQuestionTemplateView,
    end: false,
  },
  { to: '/admin/discharge-reasons', title: 'Discharge Dispositions', accessor: PERMISSIONS.adminDischargeReasonView },
  { to: '/admin/plans', title: 'Plans', accessor: PERMISSIONS.adminClassificationView },
  { to: '/admin/plan-types', title: 'Plan Types', accessor: PERMISSIONS.adminClassificationView },
  { to: '/admin/episode-types', title: 'Episode Types', accessor: PERMISSIONS.adminClassificationView },
  { to: '/admin/feature-flags', title: 'Feature Flags', accessor: PERMISSIONS.adminFeatureFlagView },
  { to: '/admin/import-history', title: 'Import History', accessor: PERMISSIONS.adminImportedPatientView },
  { to: '/admin/bulk-import', title: 'Bulk Import', accessor: PERMISSIONS.adminBulkImportView },
  { to: '/admin/shared-records', title: 'Shared Records', accessor: PERMISSIONS.adminLinkedRecordView },
  {
    to: '/admin/coordination-requests',
    title: 'Coordination Requests',
    accessor: PERMISSIONS.adminCoordinateRequestView,
  },
  { to: '/admin/portal-systems', title: 'Portal Systems', accessor: PERMISSIONS.adminClientView },
  {
    title: 'Workflows',
    accessor: PERMISSIONS.adminWorkflowLookupView,
    children: [{ to: '/admin/workflows/lookups', title: 'Lookups', accessor: PERMISSIONS.adminWorkflowLookupView }],
  },
];
